package learning.containers

import com.jingfangpai.api.clients.AcupointApiClient
import com.jingfangpai.api.clients.CommentApiClient
import com.jingfangpai.api.clients.ContentApiClient
import com.jingfangpai.api.clients.MedicineApiClient
import com.jingfangpai.api.clients.PrescriptionApiClient
import com.jingfangpai.api.clients.SignSymptomApiClient
import com.jingfangpai.common.data.response.ApiResponse
import com.jingfangpai.common.orm.mapping.Comment
import com.jingfangpai.common.orm.mapping.enums.CommentEntityType
import com.jingfangpai.common.orm.mapping.enums.CommentType
import com.jingfangpai.content.model.ContentVo
import react.*
import react.dom.div
import setTitle
import learning.components.ShanghanlunDetail
import learning.components.NotesSection
import learning.components.NotesSectionContext
import learning.components.NotesSectionContextData

external interface ShanghanlunDetailPageProps : RProps {
    var id: String
}

data class ShanghanlunDetailPageContextData(
    val query: (query: com.jingfangpai.content.model.ContentQuery, okCallback: (result: ApiResponse<Array<ContentVo>>) -> Unit, errorCallback: (exception: Throwable) -> Unit) -> Unit
)

val ShanghanlunDetailPageContext = createContext(ShanghanlunDetailPageContextData(
    ContentApiClient::query
))

val ShanghanlunDetailPageProvider = functionalComponent<ShanghanlunDetailPageProps> { props ->

    setTitle("条文详情")

    useEffectOnce { }

    ShanghanlunDetailPageContext.Provider(ShanghanlunDetailPageContextData(
        ContentApiClient::query
    )) {
        NotesSectionContext.Provider(NotesSectionContextData(
            CommentApiClient::getComments,
            CommentApiClient::save
        )) {
            div("ShanghanlunDetailPage-page") {
                child(ShanghanlunDetail) {
                    attrs {
                        contentId = props.id
                    }
                }
            }
        }
    }
}
